/* eslint-disable no-underscore-dangle,class-methods-use-this */
import lazyAssetsObserver from 'js/lib/lazy_assets';
import React from 'react';
import PropTypes from 'prop-types';
import SearchResultCards from 'js/searches/search_result_cards';

const { $, LP } = window;
const LpBoclips = LP.module('LpBoclips');

class LpBoclipsSearchPage extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMoreLess = this.toggleMoreLess.bind(this);
    this.viewAll = this.viewAll.bind(this);
    this._onChange = this._onChange.bind(this);
    this.onBackForwardNavigation = this.onBackForwardNavigation.bind(this);
    this.onResize = this.onResize.bind(this);
    this.store = this.props.context.getStore('VideoModeStore');
    this.state = this._stateFromStores();
  }

  loadingCell(index) {
    let loadingClass = 'lp-loading-cell';
    return (
      <div key={index} className={loadingClass}>
        <div className="lp-loading-bg"></div>
      </div>
    );
  }

  loadingCellCount() {
    if (this.state.viewMore) {
      return 12;
    }
    if (this.state.viewAll) {
      return 24;
    }
    if (this.state.viewFull) {
      return 48;
    }
    return 4;
  }

  defaultPerPage() {
    if (LP.isMobile() && this.state.clientWidth <= 599) {
      return 2;
    }
    if (this.state.clientWidth >= 768 && this.state.clientWidth <= 991) {
      return 4;
    }
    return 3;
  }

  numberOfHiddenVideos() {
    if (this.state.viewAll || this.state.viewFull) {
      return 0;
    }
    const defaultVideosOnPage = this.defaultPerPage();
    let videosHidden = 12 - defaultVideosOnPage;
    const remaining =
      this.state.rawVideosCount -
      (this.state.page - 1) * (videosHidden + defaultVideosOnPage) -
      defaultVideosOnPage;
    if (remaining <= 0) {
      return 0;
    }
    if (remaining < videosHidden) {
      return remaining;
    }
    return videosHidden;
  }

  showHideMoreSection() {
    if (this.state.viewAll || this.state.viewFull) {
      return false;
    }
    return this.numberOfHiddenVideos() > 0;
  }

  resultsLoader() {
    const self = this;
    return (
      <div id="boclips-results-loader">
        <div className="video-results-loader">
          {Array.from({ length: this.loadingCellCount() }).map(function (elem, index) {
            return self.loadingCell(index);
          })}
        </div>
      </div>
    );
  }

  render() {
    if (!this.state.valid) {
      return null;
    }
    return (
      <div>
        <div id="boclips-search-page" className="pt-3 border-t">
          <div id="boclips-heading">
            <div className="video-resources-title">
              <span id="boclips-videos">
                Videos
                <span id="total-videos" className="total-videos">
                  <span className="total">
                    ({this.processVideoCount(this.state.rawVideosCount)})
                  </span>
                </span>
              </span>
              {!this.state.apiUnavailable && this.showHideMoreSection() && (
                <span>
                  {this.numberOfHiddenVideos() > 0 && (
                    <a className="view-all-videos" onClick={this.viewAll}>
                      <span className="text">View all</span>
                      <i className="lp-icon fa-solid fa-angle-right"></i>
                    </a>
                  )}
                  <span className="show-more-videos pull-right">
                    <span className="show-text" onClick={this.toggleMoreLess}>
                      <span id="show-text" className="text">
                        {`Show ${this.numberOfHiddenVideos()} more`}
                      </span>
                      <i className="lp-icon fa-solid fa-angle-down"></i>
                    </span>
                    <span className="hide-text" onClick={this.toggleMoreLess}>
                      <span className="text">Hide</span>
                      <i className="fa-solid fa-angle-up"></i>
                    </span>
                  </span>
                </span>
              )}
            </div>
          </div>
          <div id="boclips-body-container">
            <div id="boclips-results-loader-container">
              {(this.state.loading || this.state.triggerSearch) && this.resultsLoader()}
            </div>
            <div
              id="search-videos-boclips"
              className="search-results-container bc-video-wrap grid gap-4 md:gap-6 lg:gap-8 grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 mb-5"
              dangerouslySetInnerHTML={{ __html: this.results() }}
            ></div>
          </div>
          {!this.state.apiUnavailable &&
            this.showHideMoreSection() &&
            this.numberOfHiddenVideos() > 0 && (
              <a className="view-all-videos-btn" onClick={this.viewAll}>
                <span className="text">View all videos</span>
                <i className="fa-solid fa-angle-right"></i>
              </a>
            )}
          <div className="other-resources-title">
            Other Resource Types
            <span id="boclips-other-resources-count" className="total">
              ({this.numberWithDelimiter(this.state.searchResultsCount)})
            </span>
          </div>
        </div>
      </div>
    );
  }

  // currently the API returns total as 10.000
  // even if actually there are more videos
  // for that particular search and we have
  // no way of of telling how much they are actually
  // so in that case we use a different label
  processVideoCount(number) {
    const processedText = this.numberWithDelimiter(number);
    const maxLimit = 10000;
    if (number !== maxLimit) {
      return processedText;
    }
    if (this.store.filteredByKeywords()) {
      return `${processedText} +`;
    }
    return `${this.numberWithDelimiter(2000000)} +`;
  }

  numberWithDelimiter(number, delimiter) {
    var number = `${number}`;
    var delimiter = delimiter || ',';
    const split = number.split('.');
    split[0] = split[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${delimiter}`);
    return split.join('.');
  }

  results() {
    if (this.state.loading || this.state.triggerSearch) {
      return null;
    }
    return this.state.results;
  }

  onResize() {
    const { clientWidth } = document.getElementsByTagName('body')[0];
    if (clientWidth !== this.state.clientWidth) {
      this.setState({ clientWidth });
    }
  }

  componentDidMount() {
    this.store.addChangeListener(this._onChange);
    window.addEventListener('resize', this.onResize);
    window.addEventListener('popstate', this.onBackForwardNavigation);
    this.bindRemoveFacet();
    if (this.state.loading || this.state.triggerSearch) {
      this.showLoading();
    }
  }

  componentWillUnmount() {
    this.store.removeChangeListener(this._onChange);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('popstate', this.onBackForwardNavigation);
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.loading === true && this.state.loading === false) {
      this.loadLazyImages();
      this._callbackAfterResourcesLoad();
    }
  }

  onBackForwardNavigation(e) {
    const historyState = e.state;
    if (historyState !== null && typeof historyState !== 'undefined') {
      this.props.context.executeAction(
        LpBoclips.LpBoclipsActions.onHistoryChange,
        historyState
      );
    }
  }

  _stateFromStores() {
    const state = this.store.currentState();
    state.clientWidth = document.getElementsByTagName('body')[0].clientWidth;
    return state;
  }

  _onChange() {
    this.setState(this._stateFromStores(), this._afterSetState);
  }

  _afterSetState() {
    if (this.state.fromBackOrForwardButton && this.state.historyNavigationTriggerSearch) {
      this.props.context.executeAction(
        LpBoclips.LpBoclipsActions.onBackForwardNavigation
      );
    }
    this.onReceivedFacets();
    this.searchApi();
  }

  onReceivedFacets() {
    if (this.store.hasReceivedFacetsFirstTime()) {
      this.props.context.executeAction(LpBoclips.LpBoclipsActions.onReceivedFacets);
    }
    if (
      this.store.hasReceivedFacetsFirstTime() &&
      this.state.viewAll &&
      !this.state.onlyVideo
    ) {
      this.props.context.executeAction(
        LpBoclips.LpBoclipsActions.clearProviderTypesAndAddVideo
      );
    }
    if (this.state.resetView) {
      this.props.context.executeAction(LpBoclips.LpBoclipsActions.resetView);
    }
  }

  toggleMoreLess(event) {
    this.props.context.executeAction(LpBoclips.LpBoclipsActions.toggleMoreLess);
    $('#boclips-videos-section .show-more-videos').toggleClass('showing-more');
    $('#boclips-videos-section').toggleClass('showing-more');
  }

  viewAll(event) {
    this.props.context.executeAction(LpBoclips.LpBoclipsActions.toggleViewAll);
    this.props.context.executeAction(
      LpBoclips.LpBoclipsActions.clearProviderTypesAndAddVideo
    );
    $('#boclips-videos-section .show-more-videos').toggleClass('showing-all');
    $('#boclips-videos-section').toggleClass('showing-all');
  }

  showLoading() {
    $('#boclips-videos-section')
      .removeClass('loading-boclips-videos-section')
      .addClass('loading-boclips-videos-section');
    if (this.state.valid) {
      $('#js-search-heading').addClass('invisible');
    } else {
      $('#js-search-heading').removeClass('invisible');
    }
    if (!this.state.loading) {
      this.setState({ loading: true });
    }
  }

  hideLoading() {
    $('#boclips-videos-section').removeClass('loading-boclips-videos-section');
    $('#js-search-heading').removeClass('invisible').css({ visibility: 'visible' });
    if (this.state.loading) {
      this.setState({ loading: false });
    }
  }

  searchApi(additionalParams) {
    this.checkPerPage();
    if (this.state.loading || this.state.triggerSearch) {
      this.showLoading();
    }
    if (this.state.resetView || !this.state.triggerSearch || !this.state.valid) {
      return;
    }
    const self = this;
    this._constructSearches(additionalParams, function () {
      self._callbackAfterAjaxFinishes();
    });
  }

  _constructSearches(additionalParams, successCallback) {
    const self = this;
    if (!additionalParams) {
      additionalParams = {};
    }
    this.props.context.executeAction(
      LpBoclips.LpBoclipsActions.loadSearch,
      additionalParams,
      function (rawSearch) {
        successCallback.call();
      }
    );
  }

  _callbackAfterResourcesLoad() {
    this.bindPlayer();
    this.bindCollectionBuilderDragAndDrop();
  }

  checkPerPage() {
    if (this.state.loading || this.state.triggerSearch) {
      this.showLoading();
    }
    this.props.context.executeAction(
      LpBoclips.LpBoclipsActions.updateLayoutBasedOnCollectionBuilder
    );
    $('#boclips-videos-section .show-more-videos')
      .removeClass('showing-full')
      .removeClass('showing-all')
      .removeClass('showing-more');
    $('#boclips-videos-section')
      .removeClass('showing-full')
      .removeClass('showing-all')
      .removeClass('showing-more');
    if (this.state.viewMore) {
      $('#boclips-videos-section .show-more-videos').addClass('showing-more');
      $('#boclips-videos-section').addClass('showing-more');
    } else if (this.state.viewFull) {
      $('#boclips-videos-section .show-more-videos').addClass('showing-full');
      $('#boclips-videos-section').addClass('showing-full');
    } else if (this.state.viewAll) {
      $('#boclips-videos-section .show-more-videos').addClass('showing-all');
      $('#boclips-videos-section').addClass('showing-all');
    }
  }

  _callbackAfterAjaxFinishes() {
    this.checkPerPage();
    this.hideLoading();
  }

  bindPlayer() {
    const self = this;
    $(document).off('click touch touchstart', '.bc-video');
    $(document).on('click touch touchstart', '.bc-video', function (event) {
      event.stopPropagation();
      if (!LP.isPhone()) {
        event.preventDefault();
        const $link = $(event.currentTarget);
        const data = $link.parent().data();
        self.props.context.executeAction(LpBoclips.LpBoclipsActions.showResource, {
          url: data.url,
          title: data.title,
          transition: data.transition,
          videoUrl: data.videoUrl,
          type: 'boclips_video'
        });
      }
    });
  }

  bindRemoveFacet() {
    const self = this;
    $(document).off('click', '.selected-facets span.label.clickable');
    $(document).on('click', '.selected-facets span.label.clickable', function (event) {
      if (self.state.viewAll && self.state.onlyVideo && $(this).text() === 'All Videos') {
        self.props.context.executeAction(LpBoclips.LpBoclipsActions.resetView);
      }
    });
  }

  bindCollectionBuilderDragAndDrop() {
    SearchResultCards.allowToBeAddedToCollections();
  }

  loadLazyImages() {
    lazyAssetsObserver.observe();
  }
}

LpBoclipsSearchPage.propTypes = {
  context: PropTypes.object
};

LpBoclips.LpBoclipsSearchPage = LpBoclipsSearchPage;
